<div class="btn-group" role="group">
  <button
    type="button"
    [attr.part]="actionButtonPart"
    [ngClass]="{
      'btn': true,
      'disabled': state === AsyncActionState.ACTIVE,
      'btn-primary': state === AsyncActionState.IDLE || state === AsyncActionState.ACTIVE,
      'btn-success': state === AsyncActionState.COMPLETE,
      'btn-danger': state === AsyncActionState.ERROR
    }"
    [attr.aria-disabled]="state === AsyncActionState.ACTIVE"
    (click)="onActionButtonClick()">
    <slot>Download</slot>
    <div *ngIf="state === AsyncActionState.ACTIVE" part="active-spinner" class="ml-2 spinner-grow spinner-grow-sm" role="status">
      <span class="sr-only">Loading...</span>
    </div>
    <svg *ngIf="state === AsyncActionState.COMPLETE" xmlns="http://www.w3.org/2000/svg" part="complete-icon" class="icon ml-2" viewBox="0 0 16 16" role="img">
      <title>Complete</title>
      <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
    </svg>
    <svg *ngIf="state === AsyncActionState.ERROR" xmlns="http://www.w3.org/2000/svg" part="failure-icon" class="icon ml-2" viewBox="0 0 16 16" role="img">
      <title>Failure</title>
      <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M8 4a.905.905 0 0 0-.9.995l.35 3.507a.552.552 0 0 0 1.1 0l.35-3.507A.905.905 0 0 0 8 4m.002 6a1 1 0 1 0 0 2 1 1 0 0 0 0-2"/>
    </svg>
  </button>
  <div *ngIf="showOptions" class="btn-group dropdown" role="group">
    <button
      part="options-button"
      type="button"
      [ngClass]="{
        'btn dropdown-toggle': true,
        'disabled': state === AsyncActionState.ACTIVE,
        'btn-primary': state === AsyncActionState.IDLE || state === AsyncActionState.ACTIVE,
        'btn-success': state === AsyncActionState.COMPLETE,
        'btn-danger': state === AsyncActionState.ERROR
      }"
      [attr.aria-expanded]="optionsMenuVisible"
      [attr.aria-disabled]="state === AsyncActionState.ACTIVE"
      (click)="onOptionsButtonClick()"
      (blur)="onOptionsButtonBlur($event)">
      <span class="sr-only">Show additional download options</span>
    </button>
    <div
      tabindex="-1"
      part="options-menu"
      [ngClass]="{
        'dropdown-menu dropdown-menu-right': true,
        'show': optionsMenuVisible
      }"
      (blur)="this.toggleOptionsMenuVisibility(false)"
      #optionsMenu>
      <ng-container *ngIf="disposition === 'attachment'; then attachmentOptionsMenuItems; else inlineMenuOptionsMenuItems"></ng-container>
      <ng-template #attachmentOptionsMenuItems>
        <button class="dropdown-item" (click)="onActionButtonClick('inline')" #optionsMenuItem>
          Open in a new tab
        </button>
      </ng-template>
      <ng-template #inlineMenuOptionsMenuItems>
        <button class="dropdown-item" (click)="onActionButtonClick('attachment')" #optionsMenuItem>
          Download
        </button>
      </ng-template>
    </div>
  </div>
</div>

<p *ngIf="errorMessage" class="form-text text-danger" part="error-message">
  {{ errorMessage }}
</p>
